export enum TeamMemberChangeSectionDTO {
  INFO = 'INFO',
  BILLING = 'BILLING',
  CAPACITY = 'CAPACITY',
  INTEGRATIONS = 'INTEGRATIONS',
}

export type TeamMemberChangeSectionRequest = TeamMemberChangeSectionDTO;
export type TeamMemberChangeSectionResponse = TeamMemberChangeSectionDTO;
